<ng-container *ngIf="gifts && gifts.length else errorLoadingGifts">
  <app-gifts-list [visitId]="visitId"></app-gifts-list>
</ng-container>

<ng-template #errorLoadingGifts>
  <div class="container-narrow my-5">
    <div class="row mt-5">
      <div class="col-12">
        <h1 class="h3 fw-bolder"
            [translate]="'GIFTS.LIST-VIEW.ERROR-GENERAL.TITLE'"></h1>
        <p class="pre-wrap"
           [translate]="'GIFTS.LIST-VIEW.ERROR-GENERAL.DESCRIPTION'"></p>
      </div>
    </div>
  </div>
</ng-template>
